

var chooseCity = function(el){
	var frame = el.querySelector('[data-js="frame"]'),
		close = frame.querySelector('[data-js="close"]'),
		btn = document.getElementById('chooseCity-btn'),
		city = btn.querySelector('[data-js="chooseCity-name"]').firstChild,
		cityName = city.nodeValue,
		isOpen = false,
		shangeShow = function(){
			if(isOpen) {
				isOpen = false;
				el.style.height = '0px';
				city.nodeValue = cityName;
				btn.className = btn.className.replace(/\s*js-active/, '');
			}
			else{
				isOpen = true;
				var h = frame.getBoundingClientRect().bottom - frame.getBoundingClientRect().top;
				el.style.height = h + 'px';
				city.nodeValue = 'Закрыть';
				btn.className = btn.className + ' js-active';
			}
			return false;
		};
	
	//
	btn.onclick = shangeShow;
	close.onclick = function(){
		if(isOpen) shangeShow();
	}
};

export {chooseCity};











